import React from "react";
import { Routes, Route } from "react-router-dom";

// ================= PUBLIC PAGES =================
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import About from "./pages/About";
import AffiliateProgram from "./pages/AffiliateProgram";
import PricingPlans from "./pages/PricingPlans";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsPage from "./pages/TermsPage";
import Realtors from "./pages/Realtors";
import Wholesalers from "./pages/Wholesalers";

// ================= APP PAGES =================
import ChatPage from "./pages/ChatPage";
import SubscriptionPage from "./pages/SubscriptionPage";
import OffMarketProperties from "./pages/OffMarketProperties";
import OffMarketListing from "./pages/OffMarketListing";
import Saved from "./pages/Saved";

// ================= PROVIDER PAGES =================
import ProviderDashboard from "./pages/ProviderDashboard";
import CreateListing from "./pages/CreateListing";

// ================= ADMIN PAGES =================
import AdminListings from "./pages/AdminListings";

// ================= LAYOUT + PROTECTION =================
import AppLayout from "./layouts/AppLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";

// ================= FALLBACK =================
import NotFoundPage from "./pages/NotFoundPage";

function App() {
  return (
    <Routes>

      {/* ================= PUBLIC (NO LAYOUT) ================= */}
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      {/* ================= PUBLIC (WITH APP LAYOUT) ================= */}
      <Route element={<AppLayout />}>
        <Route path="/about" element={<About />} />
        <Route path="/affiliate-program" element={<AffiliateProgram />} />
        <Route path="/pricing-plans" element={<PricingPlans />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsPage />} />

        {/* NEW PAGES */}
        <Route path="/realtors" element={<Realtors />} />
        <Route path="/wholesalers" element={<Wholesalers />} />

        {/* OFF-MARKET */}
        <Route path="/off-market" element={<OffMarketProperties />} />
        <Route path="/off-market/:id" element={<OffMarketListing />} />
      </Route>

      {/* ================= PROTECTED (AUTH REQUIRED) ================= */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/saved" element={<Saved />} />
        <Route path="/subscription" element={<SubscriptionPage />} />

        {/* ===== PROVIDER ROUTES ===== */}
        <Route path="/provider" element={<ProviderDashboard />} />
        <Route path="/provider/create" element={<CreateListing />} />
      </Route>

      {/* ================= ADMIN (ADMIN ONLY) ================= */}
      <Route
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AppLayout />
            </AdminRoute>
          </ProtectedRoute>
        }
      >
        <Route path="/admin/listings" element={<AdminListings />} />
      </Route>

      {/* ================= FALLBACK ================= */}
      <Route path="*" element={<NotFoundPage />} />

    </Routes>
  );
}

export default App;